
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import FaqSectionn from './FaqKeywordd';
import TestimonialSectionkey from './TestimonialSectionKeywordd';

function Punetokonkandarshancabs() {



  const cardData =
  {
    keyword: ' Pune to Konkan Darshan Cabs',
    heading: 'Vaishnavi Travels: Pune to Konkan Darshan Cabs',
    headingDescription: 'Vaishnavi Travels provides affordable and comfortable Pune to Konkan Darshan Cabs, perfect for family vacations, religious yatras, weekend getaways, and group tours. Our cabs are well-maintained with spacious seating, strong air-conditioning, and ample luggage capacity, ensuring a smooth and enjoyable journey through the scenic Konkan routes. With professional chauffeurs, timely pickups, and flexible booking options, we make long drives stress-free and reliable. Whether it’s exploring Ganpatipule, Sindhudurg, Tarkarli, or other coastal destinations, Vaishnavi Travels guarantees safe, convenient, and hassle-free cab rental services for Konkan Darshan from Pune.',

    top: 'Top Places to Visit in Konkan with Vaishnavi Travels',

"topPlaces": [
  {
    "title": "Ganpatipule Beach and Temple",
    "description": "Ganpatipule, one of the most famous spots in Konkan, is known for its pristine beach and the 400-year-old Swayambhu Ganpati Temple. The golden sands, turquoise waters, and peaceful environment attract thousands of tourists. Pilgrims believe the self-manifested idol of Lord Ganesha is highly powerful. The beach is perfect for long walks, photography, and water sports. Festivals like Ganesh Chaturthi are celebrated with grandeur. Ganpatipule is Konkan’s sacred and scenic coastal gem."
  },
  {
    "title": "Sindhudurg Fort",
    "description": "Sindhudurg Fort, built by Chhatrapati Shivaji Maharaj in 1664, is a majestic sea fort located near Malvan. Spread across 48 acres, it stands strong against the Arabian Sea waves. The fort has temples, ramparts, and hidden pathways narrating Maratha naval power. Tourists enjoy exploring its historic bastions and panoramic sea views. Snorkeling and scuba diving around Malvan add adventure to the trip. Sindhudurg Fort is Konkan’s proud maritime heritage."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach, located near Malvan, is famous for its crystal-clear waters, white sands, and adventure sports. It is one of India’s top scuba diving and snorkeling destinations, offering views of coral reefs and marine life. Tourists also enjoy parasailing, boating, and dolphin-spotting rides. The calm and scenic beauty make it ideal for couples and families. The beach shacks serve delicious Malvani seafood. Tarkarli is Konkan’s adventure and water sports paradise."
  },
  {
    "title": "Harihareshwar",
    "description": "Harihareshwar, often called the 'Dakshin Kashi,' is a spiritual and scenic town in Konkan. The Harihareshwar Temple dedicated to Lord Shiva sits beautifully by the sea. The town has serene beaches, surrounded by green hills. Pilgrims believe a pradakshina (circumambulation) around the temple along the rocky shore washes away sins. The calm environment attracts both devotees and nature lovers. Harihareshwar is Konkan’s blend of divinity and coastal charm."
  },
  {
    "title": "Dapoli",
    "description": "Dapoli, also called ‘Mini Mahabaleshwar,’ is a cool coastal hill station in Ratnagiri district. It is famous for its long beaches, ancient temples, and dolphin-sighting tours. Murud and Ladghar beaches nearby attract families and adventure seekers. The town also has historic forts and caves. Its pleasant climate makes it a year-round favorite. Dapoli is Konkan’s mix of hill-station vibes and seaside beauty."
  },
  {
    "title": "Velneshwar Beach",
    "description": "Velneshwar is a quiet coastal village known for its crescent-shaped beach and the ancient Shiva temple. The serene shoreline is perfect for swimming, sunbathing, and picnics. During Maha Shivratri, the temple hosts grand celebrations. The clean and less-crowded beach attracts peace seekers and families. Coconut palms and fishing boats create a picturesque backdrop. Velneshwar is Konkan’s offbeat destination for spirituality and relaxation."
  },
  {
    "title": "Jaigad Fort and Lighthouse",
    "description": "Jaigad Fort, located near Ganpatipule, is a 16th-century sea fort offering spectacular views of the Arabian Sea. Its bastions, gateways, and water tanks narrate Maratha history. Nearby, the Jaigad Lighthouse provides a breathtaking view of the coastline. Tourists enjoy combining history with natural beauty here. It is a popular stop for photographers and history lovers. Jaigad is Konkan’s scenic and historic watchtower."
  },
  {
    "title": "Alibaug",
    "description": "Alibaug, often called the 'Goa of Maharashtra,' is a popular coastal getaway near Mumbai and Pune. Known for Alibaug, Kashid, and Nagaon beaches, it offers water sports, forts, and seaside resorts. The Kolaba Fort adds a heritage touch to the beach town. Fresh seafood and homestays enhance the experience. Weekend travelers love its accessibility and charm. Alibaug is Konkan’s gateway for fun and relaxation."
  },
  {
    "title": "Murud-Janjira Fort",
    "description": "Murud-Janjira Fort, located on an island near Murud, is an unconquered sea fort famous for its strong defense and history. Built in the 15th century, it has 19 bastions still intact today. Visitors reach it by boat and explore its palaces, water tanks, and cannons. The fort stands as a symbol of naval strength. Surrounded by the Arabian Sea, it offers stunning views. Murud-Janjira is Konkan’s legendary fort of resilience and glory."
  },
  {
    "title": "Guhagar",
    "description": "Guhagar is a serene coastal town in Ratnagiri district, known for its long, clean beach and temples. It is less commercialized, offering peace and natural beauty. The Vyadeshwar Temple dedicated to Lord Shiva is a major attraction. Coconut and betel nut plantations surround the region, adding to its charm. Families and pilgrims alike enjoy the calm environment. Guhagar is Konkan’s hidden paradise of spirituality and seashore beauty."
  }
],


    "services": [
    {
      "name": "Konkan Darshan Cab Pune",
      "description": "Experience the scenic beauty of the Konkan coast with our dedicated cab services from Pune. Whether you are planning a day trip or a multi-day tour, our comfortable vehicles and experienced drivers ensure a smooth and enjoyable journey through picturesque landscapes, beaches, and heritage sites."
    },
    {
      "name": "Pune Konkan Sightseeing Taxi",
      "description": "Explore popular Konkan destinations including Ganpatipule, Ratnagiri, Tarkarli, and more with our sightseeing taxi service. Our knowledgeable drivers can suggest local attractions and stopovers, making your sightseeing experience rich and hassle-free."
    },
    {
      "name": "AC Cab for Konkan Tour",
      "description": "Travel in cool comfort to the Konkan region with our air-conditioned cabs from Pune. These vehicles are ideal for summer trips, offering a relaxing environment to beat the heat while enjoying your scenic road trip."
    },
    {
      "name": "Budget Konkan Cabs Pune",
      "description": "Affordable cab options for travelers looking to explore Konkan without compromising on safety or reliability. Our budget cabs offer clean, well-maintained vehicles with professional drivers, perfect for solo travelers, couples, and small families."
    },
    {
      "name": "One Way Konkan Darshan",
      "description": "Choose our one-way Konkan darshan cab service for flexible travel plans. Ideal for travelers who want to reach Konkan without the hassle of return trips, with options to customize your drop-off points."
    },
    {
      "name": "Round Trip Cab Konkan",
      "description": "Book a convenient round-trip cab service from Pune to Konkan and back. Perfect for weekend getaways or planned tours, this service includes driver waiting time and multiple stopovers at your preferred locations."
    },
    {
      "name": "SUV Cab for Konkan",
      "description": "Travel in spacious comfort with our SUV cab rentals for Konkan tours. SUVs are ideal for larger groups or families needing extra luggage space and rugged vehicles suited for diverse terrain."
    },
    {
      "name": "Family Konkan Tour Pune Cab",
      "description": "Our family-friendly Konkan cab service ensures safety, comfort, and convenience for all age groups. With extra luggage space, child safety features, and courteous drivers, your family trip to Konkan will be memorable and stress-free."
    },
    {
      "name": "Corporate Konkan Darshan Cab",
      "description": "Professional cab services tailored for corporate groups visiting Konkan. Whether for team outings, client entertainment, or business retreats, our premium vehicles and punctual drivers provide a seamless experience."
    },
    {
      "name": "Konkan Drive Cab Booking",
      "description": "Book your Konkan cab easily online with instant confirmations, transparent pricing, and a variety of vehicle options to suit your needs. Our booking system is user-friendly and backed by reliable customer support."
    },
    {
      "name": "Online Cab for Konkan Trip",
      "description": "Plan your Konkan trip effortlessly with our online cab booking platform. Select from AC/non-AC, sedan or SUV, specify trip details, and enjoy hassle-free payments with full booking transparency."
    },
    {
      "name": "Konkan Trip Cab with Driver",
      "description": "Hire a cab with an experienced local driver who knows the best routes, scenic spots, and hidden gems along the Konkan coast. Our drivers ensure your safety and enrich your trip with helpful guidance."
    },
    {
      "name": "Konkan Cab Rental Packages",
      "description": "Choose from a variety of Konkan cab rental packages designed for different trip durations and group sizes. Packages include fuel, tolls, driver allowance, and customizable itineraries for a stress-free travel experience."
    }
  ],
  "tableData": [
    ["Konkan Darshan Cab Pune", "Pune Konkan Sightseeing Taxi"],
    ["AC Cab for Konkan Tour", "Budget Konkan Cabs Pune"],
    ["One Way Konkan Darshan", "Round Trip Cab Konkan"],
    ["SUV Cab for Konkan", "Family Konkan Tour Pune Cab"],
    ["Corporate Konkan Darshan Cab", "Konkan Drive Cab Booking"],
    ["Online Cab for Konkan Trip", "Konkan Trip Cab with Driver"],
    ["Konkan Cab Rental Packages"]
  ],


"whychoose": [
  {
    "WhyChooseheading": "Pune to Konkan Darshan Cabs",
    "WhyChoosedescription": "Vaishnavi Travels offers comfortable and reliable cab services from Pune to Konkan for scenic darshan tours covering temples, beaches, and heritage sites."
  },
  {
    "WhyChooseheading": "Multiple Cab Options for Every Group",
    "WhyChoosedescription": "Choose from Swift Dzire, Ertiga, Innova, or Urbania – suitable for solo travelers, families, or large groups heading to Konkan."
  },
  {
    "WhyChooseheading": "Clean, Sanitized & Well-Maintained Vehicles",
    "WhyChoosedescription": "All our vehicles are properly maintained and sanitized before each trip, ensuring hygiene and comfort during your journey."
  },
  {
    "WhyChooseheading": "Experienced Drivers with Route Expertise",
    "WhyChoosedescription": "Our drivers are well-acquainted with all major Konkan routes and sightseeing spots, ensuring a smooth and informative journey."
  },
  {
    "WhyChooseheading": "Flexible Itineraries and Travel Plans",
    "WhyChoosedescription": "Plan your own darshan tour covering temples like Ganpatipule, Kunkeshwar, Parshuram, or scenic beaches in Ratnagiri and Sindhudurg."
  },
  {
    "WhyChooseheading": "Transparent and All-Inclusive Pricing",
    "WhyChoosedescription": "No hidden fees — our pricing includes fuel, tolls, parking, and driver allowance for both one-way and round trips."
  },
  {
    "WhyChooseheading": "Ideal for Pilgrimage, Beach Holidays & Family Tours",
    "WhyChoosedescription": "Perfect for spiritual tours, relaxing beach getaways, and heritage trips across the beautiful Konkan coastline."
  },
  {
    "WhyChooseheading": "24/7 Booking Support and Travel Assistance",
    "WhyChoosedescription": "Our customer support is available round-the-clock to help you with bookings, route planning, and last-minute travel changes."
  }
]










  }




const faqData = [
  [
    {
      question: 'Does Vaishnavi Travels offer cab services for Pune to Konkan Darshan tours?',
      answer: 'Yes, Vaishnavi Travels provides comfortable and reliable cabs for Pune to Konkan Darshan tours, covering popular coastal destinations like Alibaug, Ratnagiri, Ganpatipule, and more.',
    },
    {
      question: 'What types of cabs are available for the Pune to Konkan Darshan tour?',
      answer: 'We offer a range of vehicles including Swift Dzire, Ertiga, Innova, and Tempo Traveller to suit different group sizes and comfort preferences.',
    },
    {
      question: 'Are the cabs and drivers suitable for long-distance Konkan travel?',
      answer: 'Absolutely! Our cabs are well-maintained for long journeys, and our experienced drivers are familiar with Konkan routes, offering a safe and smooth travel experience.',
    },
    {
      question: 'What is the cost of hiring a cab for a Pune to Konkan Darshan trip?',
      answer: 'Cab rental rates for Konkan Darshan typically start from ₹6,000 per day depending on the vehicle type, number of days, destinations covered, and custom requirements.',
    },
    {
      question: 'Can I customize my Konkan Darshan itinerary with Vaishnavi Travels?',
      answer: 'Yes, we offer customizable itineraries tailored to your interests, whether it’s temple visits, beaches, forts, or food exploration across the Konkan belt.',
    },
    {
      question: 'How early should I book a cab for the Pune to Konkan Darshan tour?',
      answer: 'It’s advisable to book at least 4-5 days in advance, especially during holiday seasons and long weekends, as Konkan is a popular travel destination.',
    },
    {
      question: 'Is doorstep pickup and drop available for Konkan Darshan cabs from Pune?',
      answer: 'Yes, we provide convenient doorstep pickup and drop services in Pune and nearby areas for all Konkan Darshan bookings.',
    }
  ]
];

const testimonials = [
  {
    name: "Mr. Milind Apte",
    position: "Travel Enthusiast",
    feedback:
      "We hired a cab from Vaishnavi Travels for our Konkan Darshan trip. The vehicle was comfortable and the driver was very cooperative and knowledgeable about the route and local spots.",
    rating: 5,
  },
  {
    name: "Ms. Shalini Karmarkar",
    position: "Teacher",
    feedback:
      "Our Konkan tour with Vaishnavi Travels was excellent. Clean cab, polite driver, and flexible itinerary made our family trip memorable. Will book again!",
    rating: 5,
    style: "style-2",
  }
];







































































































  const Images = [
    {
      place: "/images/keyword/1.jpg",
      text: "Bus Booking for Marriage",
      link: "bus-booking-for-marriage"
    },
    {
      place: "/images/keyword/2.jpg",
      text: "Bus Hire for Wedding in Pune",
      link: "bus-hire-for-wedding-in-pune"
    },
    {
      place: "/images/keyword/3.jpg",
      text: "Bus Hire Near Me Pune",
      link: "bus-hire-near-me-pune"
    },
    {
      place: "/images/keyword/4.jpg",
      text: "Bus Hire for Outstation",
      link: "bus-hire-for-outstation"
    },
    {
      place: "/images/keyword/5.jpg",
      text: "Bus Service for Corporate Pune",
      link: "bus-service-for-corporate-pune"
    },
    {
      place: "/images/keyword/6.jpg",
      text: "Bus Service for Corporate Events",
      link: "bus-service-for-corporate-events"
    },
    {
      place: "/images/keyword/7.jpg",
      text: "Bus Service for Picnic in Pune",
      link: "bus-service-for-picnic-in-pune"
    },
    {
      place: "/images/keyword/8.jpg",
      text: "Bus Rentals for School Trips in Pune",
      link: "bus-rentals-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/9.jpg",
      text: "Bus Hire for School Trips in Pune",
      link: "bus-hire-for-school-trips-in-pune"
    },
    {
      place: "/images/keyword/10.jpg",
      text: "Bus Rental for Tour Packages",
      link: "bus-rental-for-tour-packages"
    },
    {
      place: "/images/keyword/11.jpg",
      text: "Bus on Rent for Event in Pune",
      link: "bus-on-rent-for-event-in-pune"
    },
    {
      place: "/images/keyword/12.jpg",
      text: "Non AC Bus Rental Service in Pune",
      link: "non-ac-bus-rental-service-in-pune"
    },
    {
      place: "/images/keyword/13.jpg",
      text: "AC Bus On Rent in Pune",
      link: "ac-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/14.jpg",
      text: "Pune Local Bus on Rent",
      link: "pune-local-bus-on-rent"
    },
    {
      place: "/images/keyword/15.jpg",
      text: "Bus On Rent in Pimpri Chinchwad",
      link: "bus-on-rent-in-pimpri-chinchwad"
    },
    {
      place: "/images/keyword/16.jpg",
      text: "25 Seater Tempo Traveller on Rent in Pune",
      link: "25-seater-tempo-traveller-on-rent-in-pune"
    },
    {
      place: "/images/keyword/17.jpg",
      text: "32 Seater Bus Rent in Pune",
      link: "32-seater-bus-rent-in-pune"
    },
    {
      place: "/images/keyword/18.jpg",
      text: "35 Seater Bus on Rent in Pune",
      link: "35-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/19.jpg",
      text: "40 Seater Bus on Rent in Pune",
      link: "40-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/20.jpg",
      text: "45 Seater Bus on Rent in Pune",
      link: "45-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/21.jpg",
      text: "50 Seater Bus on Rent in Pune",
      link: "50-seater-bus-on-rent-in-pune"
    },
    {
      place: "/images/keyword/22.jpg",
      text: "32 Seater Tempo Traveller Service",
      link: "32-seater-tempo-traveller-service"
    },
    {
      place: "/images/keyword/23.jpg",
      text: "Pune to Mumbai Darshan Bus on Rent",
      link: "pune-to-mumbai-darshan-bus-on-rent"
    },
    {
      place: "/images/keyword/24.jpg",
      text: "Pune to Shirdi Bus Hire",
      link: "pune-to-shirdi-bus-hire"
    },
    {
      place: "/images/keyword/25.jpg",
      text: "Pune to Ganpatipule Beach Bus Rental Service",
      link: "pune-to-ganpatipule-beach-bus-rental-service"
    }
  ];


const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Konkan Darshan Cab Service",
  "image": "https://vaishnavitravel.com/assets/images/pune-to-konkan-darshan-cab.jpg",
  "description": "Book AC and budget cabs from Pune to Konkan for sightseeing tours, one-way and round trips. Reliable SUV and family cabs available for corporate and leisure travel.",
  "brand": {
    "@type": "Brand",
    "name": "Vaishnavi Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "110"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2200",
    "availability": "https://schema.org/InStock",
    "url": "https://vaishnavitravel.com/pune-to-konkan-darshan-cab"
  }
};




  return (
    <div>
<Helmet>
  <title>Pune to Konkan Darshan Cab | AC & Budget Taxi Booking</title>
  <meta
    name="description"
    content="Book AC and budget cabs from Pune to Konkan for sightseeing tours, one-way and round trips. Reliable SUV and family cabs available for corporate and leisure travel."
  />
  <meta
    name="keywords"
    content="Konkan Darshan Cab Pune, Pune Konkan Sightseeing Taxi, AC Cab for Konkan Tour, Budget Konkan Cabs Pune, One Way Konkan Darshan, Round Trip Cab Konkan, SUV Cab for Konkan, Family Konkan Tour Pune Cab, Corporate Konkan Darshan Cab, Konkan Drive Cab Booking, Online Cab for Konkan Trip, Konkan Trip Cab with Driver, Konkan Cab Rental Packages"
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section
        className="breadcrumb-wrapper fix bg-cover"
        style={{ backgroundImage: "url(/img/breadcrumb/breadcrumb.jpg)" }}>
        <div className="container">
          <div className="row">
            <div className="page-heading">
              <h2>{cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </section>


      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/54.jpg' alt='img'  className='img-fluid'/>
              <h3 className="py-1"
                style={{
                  color: '#062349', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Vaishnavi Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vaishnavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">
                        <FaqSectionn idPrefix="faq-section-1" faqItems={faqData} />

                      </div>
                    </div>
                  </div>
                </div>
              </div>


              <TestimonialSectionkey
                title="Our Clients Feedback"
                subtitle="Testimonial"
                testimonials={testimonials}
              />

              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919765685295" className="pc-call">+91 9765685295</a>
                      <a href="tel:+919881872524" className="pc-call">+91 9881872524</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919765685295"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919765685295" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@vaishnavitravel.com" className="pc-email">
                      booking@vaishnavitravel.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Vaishnavi Travels</strong><br />
                      Shop No 5, HQPJ+3J3, New DP Rd, near Cell Petroleum, Akshay Nagar Society, Nandanwan Society, Vishal Nagar, Pimple Nilakh, Pimpri-Chinchwad, Pune, Maharashtra 411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetokonkandarshancabs;